const formikValidation = (data) => {

  let errors = {}

  if (!data.orgao) {
    errors.orgao = "Órgão de origem Obrigatório"
  }

  return errors;
}

export default formikValidation;
